export const FIREBASE_CREDENTIALS = {
  apiKey: "AIzaSyBfvL4G0JiCXAoRvquUYdxT6dY-I-33DBQ",
  authDomain: "nps-jarbas-doles.firebaseapp.com",
  databaseURL: "https://nps-jarbas-doles.firebaseio.com",
  projectId: "nps-jarbas-doles",
  storageBucket: "nps-jarbas-doles.appspot.com",
  messagingSenderId: "983308794556"
};